(() => {
  if (window.RollMyLogoClickEvents || window.Shopify?.designMode || document.body.hasAttribute('data-rml-preview')) return;
  window.RollMyLogoClickEvents = true;
  const inks = { '#09090a': 'Black', '#4157ff': 'Blue', '#e74132': 'Red', '#167548': 'Green', '#ffffff': 'White', '#f2c600': 'Yellow' };
  const widths = { '40': 'Standard', '50': 'Wide', '60': 'ExtraWide' };
  const methods = { upload: 'Logo_UploadNow', later: 'Logo_SendLater' };
  const markerActions = { black: 'Marker_AddBlack', blue: 'Marker_AddBlue', red: 'Marker_AddRed', green: 'Marker_AddGreen', white: 'Marker_AddWhite', yellow: 'Marker_AddYellow' };
  const readySizes = { '33.7': 'S', '63.66': 'M', '95.49': 'L' };
  const destinations = { builder: 'BuildRoller', 'ready-made': 'ReadyMade', 'how-it-works': 'HowItWorks', faq: 'FAQ', 'extra-markers': 'Markers' };

  function actionFor(control) {
    const custom = control.closest('[data-custom-order]');
    if (custom) {
      if (control.matches('input[data-later-size]') && Object.hasOwn(widths, control.value)) return `CustomSize_${widths[control.value]}`;
      if (control.matches('input[data-later-ink]') && Object.hasOwn(inks, control.value)) return `CustomInk_${inks[control.value]}`;
      if (control.matches('[data-artwork-method]') && Object.hasOwn(methods, control.value)) return methods[control.value];
      if (control.matches('[data-order-file-choose]')) return 'Logo_ChooseFile';
      if (control.matches('[data-order-file-remove]')) return 'Logo_RemoveFile';
      if (control.matches('[data-order-continue]')) return 'Custom_Continue';
    }
    if (control.matches('.rml-size-compare')) return control.closest('[data-custom-order-only]') ? 'Custom_CompareSizes' : 'Ready_CompareSizes';
    if (control.matches('[data-size-download]')) return 'Compare_DownloadPDF';
    if (control.matches('[data-size-apply]')) return 'Compare_ApplySize';
    if (control.matches('.rml-size-guide__close')) return 'Compare_Close';
    if (control.matches('[data-ready-diameter]') && Object.hasOwn(readySizes, control.value)) return `ReadySize_${readySizes[control.value]}`;
    if (control.matches('[data-ready-ink]') && Object.hasOwn(inks, control.dataset.readyInk)) return `ReadyInk_${inks[control.dataset.readyInk]}`;
    if (control.matches('[data-ready-inverse]')) return 'Ready_ToggleInverse';
    if (control.matches('[data-ready-add]')) return 'Ready_AddButton';
    if (control.matches('[data-marker-add]')) {
      const color = control.closest('[data-marker-form]')?.dataset.markerColor;
      return Object.hasOwn(markerActions, color) ? markerActions[color] : undefined;
    }
    if (control.matches('[data-design-help-copy]')) return 'Help_CopyEmail';
    if (control.matches('.rml-design-help summary')) return 'Help_Open';
    if (control.matches('.rml-design-help__providers a')) {
      const href = control.getAttribute('href');
      if (href?.startsWith('https://mail.google.com/')) return 'Help_Gmail';
      if (href?.startsWith('https://outlook.live.com/')) return 'Help_Outlook';
    }
    if (control.matches('.rml-design-help__app')) return 'Help_EmailApp';
    if (control.matches('[data-rml-quote-open]')) return 'Business_OpenQuote';
    if (control.matches('[data-rml-quote-close]')) return 'Business_CloseQuote';
    if (control.matches('.rml-video-toggle')) return 'Video_PlayPause';
    if (control.matches('.rml-faq__list summary')) {
      const index = [...control.closest('.rml-faq__list').querySelectorAll('summary')].indexOf(control);
      return ['FAQ_Surfaces', 'FAQ_Included', 'FAQ_Production', 'FAQ_Replacement', 'FAQ_MarkerLife', 'FAQ_Ink'][index];
    }
    if (control.matches('.rml-cart-button--checkout')) return 'Cart_CheckoutButton';
    if (control.matches('.rml-cart-update')) return 'Cart_Update';
    if (control.matches('.rml-cart-remove')) return 'Cart_Remove';
    if (control.matches('.rml-cart')) return 'Header_Cart';
    if (control.matches('.rml-account')) return 'Header_Account';
    if (control.matches('.rml-hero__actions a, .rml-nav a, .rml-footer__links a, .rml-cart-empty a, .rml-faq__list a')) {
      const fragment = control.getAttribute('href')?.split('#')[1];
      if (!Object.hasOwn(destinations, fragment)) return;
      const area = control.closest('.rml-hero__actions') ? 'Hero' : control.closest('.rml-nav') ? 'Nav'
        : control.closest('.rml-footer__links') ? 'Footer' : control.closest('.rml-cart-empty') ? 'Cart' : 'FAQ';
      return `${area}_${destinations[fragment]}`;
    }
  }

  // Publish fixed action names only, never DOM text, URLs, files, or form values.
  document.addEventListener('click', event => {
    if (!event.isTrusted || event.button !== 0) return;
    const control = event.target.closest?.('button, a, input, summary');
    if (!control || control.disabled || control.getAttribute('aria-disabled') === 'true' || control.closest('[hidden]')) return;
    const action = actionFor(control);
    if (!action) return;
    try {
      window.Shopify?.analytics?.publish('rml:ButtonClicked', { event_name: `RML_${action}` })?.catch?.(() => {});
    } catch { /* Tracking failures must not affect navigation or checkout. */ }
    try { window.RollMyLogoUX?.track(`RML_${action}`); }
    catch { /* Optional usability analytics must not affect the action. */ }
  }, true);
})();
